<template>
  <v-container class="px-0 py-0" fluid>
    <v-row dense>
      <v-col>
        <EditReturnRecordForm />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import EditReturnRecordForm from '@/components/organisms/terminal/form/EditReturnRecordForm'

export default {
  name: 'EditReturnRecordPage',

  components: {
    EditReturnRecordForm,
  },
}
</script>
